import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import { TableLayout } from "../../components"
import Moment from "moment"
import { ToastContainer, ToastMessage } from "react-toastr"
import ReactPaginate from "react-paginate"
class TableContratosTrash extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.restore = this.restore.bind(this)
    this.state = {
      showLoad: false
    }
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  restore(id) {
    ApiHelper.restoreContrato(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        this.props.onRestore()
      }
    })
  }
  render() {
    var tableHeaders = [
      "Número do contrato",
      "Objeto",
      "Contratado",
      "Assinado em",
      "Final da vigência",
      "Ações"
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <TableLayout
          headerButtons={[]}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar contrato"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">{row.num_contrato}</td>
                    <td className="col-sm-5">{row.objeto}</td>
                    <td className="col-sm-4">
                      {row.contratado ? row.contratado.nome_razao_social : ""}
                    </td>
                    <td className="col-sm-2">
                      {Moment(row.data_assinado).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-2">
                      {Moment(row.final_vigencia.date).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-1 td-actions text-right">
                      <button
                        type="button"
                        rel="tooltip"
                        title="Restaurar contrato"
                        onClick={() => this.restore(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">restore</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <ReactPaginate
            previousLabel="Anterior"
            nextLabel="Próximo"
            breakLabel={<a href="">...</a>}
            breakClassName="break-me"
            pageCount={this.props.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={30}
            onPageChange={this.props.handlePageClick}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
          />
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableContratosTrash)



// WEBPACK FOOTER //
// ./src/views/contratos/TableContratosTrash.js